import { type ReactNode } from "react";
import Footer from "../sections/Footer";
import TopNav, { type PublicPage } from "./TopNav";

type PublicLayoutProps = {
  activePage: PublicPage;
  children: ReactNode;
};

export default function PublicLayout({
  children
}: PublicLayoutProps): JSX.Element {
  return (
    <div className="layout mainPage">
      <a className="skipLink" href="#main-content">
        Ugrás a tartalomhoz
      </a>
      <TopNav activePage="home" />
      <main id="main-content">{children}</main>
      <Footer />
    </div>
  );
}
